import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=e40f0f50&scoped=true&"
import script from "./BasePopup.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BasePopup.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=e40f0f50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40f0f50",
  null
  
)

export default component.exports